import Vue from 'vue'
import VueRouter from 'vue-router'
import VueSocketIO from 'vue-socket.io'
import SocketIO from 'socket.io-client'
import { getUserData, isUserLoggedIn } from '@/auth/utils'
import Config from '../../config'
import store from '@/store'

Vue.use(VueRouter)

// جلوگیری از خطای NavigationDuplicated
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // فقط خطای NavigationDuplicated رو نادیده بگیر
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/facility',
      name: 'facility-list',
      component: () => import('@/views/facility/FacilityList.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'امکانات',
            active: true,
          },
        ],
      },
    },
    {
      path: '/online-chat',
      name: 'onlineChat',
      component: () => import('@/views/OnlineChatPage.vue'), // مسیر دقیق کامپوننت را تنظیم کنید
      meta: {
        pageTitle: 'گفتگوی آنلاین',
        breadcrumb: [
          {
            text: 'گفتگوی آنلاین',
            active: true,
          },
        ],
      },
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/user/UsersView.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'پروفایل',
            active: true,
          },
        ],
      },
    },
    {
      path: '/device/list',
      name: 'device-list',
      component: () => import('@/views/device/DeviceList.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'خودروهای من',
            active: true,
          },
        ],
      },
    },
    {
      path: '/device/dashboard',
      name: 'device-dashboard',
      component: () => import('@/views/device/DeviceDashboard.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'داشبورد',
            active: true,
          },
        ],
      },
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import('@/views/Home/FAQPage.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'سوالات متداول',
            active: true,
          },
        ],
      },
    },
    // Payment Routes
    {
      path: '/payment/renew',
      name: 'subscription-renew',
      component: () => import('@/views/payment/SubscriptionRenew.vue'),
      meta: {
        pageTitle: 'تمدید اشتراک',
        breadcrumb: [
          {
            text: 'تمدید اشتراک',
            active: true,
          },
        ],
      },
    },
    {
      path: '/payment/transactions',
      name: 'payment-transactions',
      component: () => import('@/views/payment/TransactionsList.vue'),
      meta: {
        pageTitle: 'تراکنش‌های من',
        breadcrumb: [
          {
            text: 'تراکنش‌های من',
            active: true,
          },
        ],
      },
    },
    {
      path: '/payment/result',
      name: 'payment-result',
      component: () => import('@/views/payment/PaymentResult.vue'),
      meta: {
        pageTitle: 'نتیجه پرداخت',
        layout: 'full',
      },
    },
    {
      path: '/device/add',
      name: 'device-add',
      component: () => import('@/views/device/DeviceAdd.vue'),
      meta: {
        pageTitle: 'افزودن ردیاب',
        breadcrumb: [
          {
            text: 'افزودن ردیاب',
            active: true,
          },
        ],
      },
    },
    {
      path: '/newdevice',
      name: 'new-Device',
      component: () => import('@/views/authentication/new-Device.vue'),
      meta: {
        layout: 'full',
      },
    },
    /// ///////////////////////  A D M I N
    {
      path: '/admin/server/list',
      name: 'admin-server-list',
      component: () => import('@/views/admin/servergps/ServergpsList.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'سرور ها',
            active: true,
          },
        ],
      },
    },
    {
      path: '/admin/plan/list',
      name: 'admin-plan-list',
      component: () => import('@/views/admin/plan/PlanList.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'پلان ها',
            active: true,
          },
        ],
      },
    },
    {
      path: '/admin/manager/list',
      name: 'admin-manager-list',
      component: () => import('@/views/admin/manager/ManagerList.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'لیست ادمین ها',
            active: true,
          },
        ],
      },
    },
    {
      path: '/admin/manager/edit',
      name: 'admin-manager-edit',
      component: () => import('@/views/admin/manager/ManagerEdit.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'افزودن مدیر',
            active: true,
          },
        ],
      },
    },
    {
      path: '/admin/agent/list',
      name: 'admin-agent-list',
      component: () => import('@/views/admin/agent/AgentList.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'لیست نماینده ها',
            active: true,
          },
        ],
      },
    },
    {
      path: '/admin/agent/edit',
      name: 'admin-agent-edit',
      component: () => import('@/views/admin/agent/AgentEdit.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'افزودن مشتری',
            active: true,
          },
        ],
      },
    },
    {
      path: '/admin/customer/list',
      name: 'admin-customer-list',
      component: () => import('@/views/admin/customer/CustomerList.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'لیست مشتریان',
            active: true,
          },
        ],
      },
    },
    {
      path: '/admin/customer/edit',
      name: 'admin-customer-edit',
      component: () => import('@/views/admin/customer/CustomerEdit.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'اطلاعات مشتری',
            active: true,
          },
        ],
      },
    },
    {
      path: '/admin/popup-message/auth',
      name: 'admin-popup-message-auth',
      component: () => import('@/views/admin/popupMessage/PopupMessageAuth.vue'),
      meta: {
        pageTitle: '',
        layout: 'full',
        breadcrumb: [
          {
            text: 'ورود به پنل مدیریت',
            active: true,
          },
        ],
      },
    },
    {
      path: '/admin/crash-logs/list',
      name: 'admin-crash-logs-list',
      component: () => import('@/views/admin/crashLog/CrashLogList.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'لاگ‌های خطای اپلیکیشن',
            active: true,
          },
        ],
      },
    },
    {
      path: '/admin/popup-message/list',
      name: 'admin-popup-message-list',
      component: () => import('@/views/admin/popupMessage/PopupMessageList.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'مدیریت پیام‌های پاپ‌آپ',
            active: true,
          },
        ],
      },
    },
    {
      path: '/admin/device/add',
      name: 'admin-device-add',
      component: () => import('@/views/admin/device/DeviceAdd.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'افزودن ردیاب',
            active: true,
          },
        ],
      },
    },
    {
      path: '/admin/device/edit',
      name: 'admin-device-edit',
      component: () => import('@/views/admin/device/DeviceEdit.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'ویرایش ردیاب',
            active: true,
          },
        ],
      },
    },
    {
      path: '/admin/device/all',
      name: 'admin-device-all',
      component: () => import('@/views/admin/device/DeviceAll.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'لیست دستگاه ها',
            active: true,
          },
        ],
      },
    },
    {
      path: '/admin/device/statistics',
      name: 'admin-device-statistics',
      component: () => import('@/views/admin/statistics/DeviceStatistics.vue'),
      meta: {
        pageTitle: 'آمار دستگاه‌ها',
        breadcrumb: [
          {
            text: 'آمار دستگاه‌ها',
            active: true,
          },
        ],
      },
    },
    {
      path: '/admin/server/monitoring',
      name: 'admin-server-monitoring',
      component: () => import('@/views/admin/statistics/ServerMonitoring.vue'),
      meta: {
        pageTitle: 'مانیتورینگ سرور',
        breadcrumb: [
          {
            text: 'مانیتورینگ سرور',
            active: true,
          },
        ],
      },
    },
    {
      path: '/admin/model/list',
      name: 'admin-model-list',
      component: () => import('@/views/admin/model/ModelList.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [
          {
            text: 'مدل ها',
            active: true,
          },
        ],
      },
    },
    // Payment Admin Routes
    {
      path: '/admin/payment/config',
      name: 'admin-payment-config',
      component: () => import('@/views/admin/payment/PaymentConfig.vue'),
      meta: {
        pageTitle: 'تنظیمات درگاه پرداخت',
        breadcrumb: [
          {
            text: 'تنظیمات درگاه پرداخت',
            active: true,
          },
        ],
      },
    },
    {
      path: '/admin/payment/transactions',
      name: 'admin-payment-transactions',
      component: () => import('@/views/admin/payment/TransactionsList.vue'),
      meta: {
        pageTitle: 'لیست تراکنش‌ها',
        breadcrumb: [
          {
            text: 'لیست تراکنش‌ها',
            active: true,
          },
        ],
      },
    },

    {
      path: '/admin/address-logs',
      name: 'admin-address-logs',
      component: () => import('@/views/admin/addressLog/AddressLogList.vue'),
      meta: {
        pageTitle: 'آمار درخواست آدرس',
        breadcrumb: [
          {
            text: 'آمار درخواست آدرس',
            active: true,
          },
        ],
      },
    },
    {
      path: '/set-password',
      name: 'set-password',
      component: () => import('@/views/authentication/SetPassword.vue'),
      meta: {
        pageTitle: 'تنظیم رمز عبور',
        breadcrumb: [
          {
            text: 'تنظیم رمز عبور',
            active: true,
          },
        ],
      },
    },

    /// ///////////////////////  A U T H
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/authentication/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/authentication/Register.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/login-password',
      name: 'login-password',
      component: () => import('@/views/authentication/LoginPassword.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: () => import('@/views/authentication/ResetPassword.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/login-verify',
      name: 'login-verify',
      component: () => import('@/views/authentication/Login-Verify.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/register-verify',
      name: 'register-verify',
      component: () => import('@/views/authentication/Register-Verify.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/index.html',
      redirect: '/',
    },
    {
      path: '*',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
     // redirect: 'error-404',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  Vue.prototype.pathname = to.path
  if (to.path === '/login') {
    if (isUserLoggedIn()) {
      router.push({ path: '/' })
      /*
      if (window.innerWidth < 768) {
        router.push({ path: '/device/list' })
      } else {
        router.push({ path: '/' })
      } */
    }
    return next()
  }
  if (to.path === '/register') {
    if (isUserLoggedIn()) {
      router.push({ path: '/' })
      /*
      if (window.innerWidth < 768) {
        router.push({ path: '/device/list' })
      } else {
        router.push({ path: '/' })
      }

       */
    }
    return next()
  }
  if (to.path === '/register-verify') {
    if (isUserLoggedIn()) {
      router.push({ path: '/' })
      /*
      if (window.innerWidth < 768) {
        router.push({ path: '/device/list' })
      } else {
        router.push({ path: '/' })
      }

       */
    }
    return next()
  }
  if (to.path === '/login-password') {
    if (isUserLoggedIn()) {
      router.push({ path: '/' })
    }
    return next()
  }
  if (to.path === '/reset-password') {
    if (isUserLoggedIn()) {
      router.push({ path: '/' })
    }
    return next()
  }
  if (to.path === '/login-verify') {
    if (isUserLoggedIn()) {
      router.push({ path: '/' })
    }
    return next()
  }
  if (to.path === '/newdevice') {
    if (isUserLoggedIn()) {
      router.push({ path: '/' })
      /*
      if (window.innerWidth < 768) {
        router.push({ path: '/device/list' })
      } else {
        router.push({ path: '/' })
      }

       */
    }
    return next()
  }
  
  // Admin auth page doesn't require login
  if (to.path === '/admin/popup-message/auth') {
    return next()
  }

  if (!isUserLoggedIn()) {
    router.push({ path: '/login' })
  }
  // اتصال سوکت
  /* Establish Connection */

  if (isUserLoggedIn() && !Vue.prototype.$socket) {
    if (localStorage.getItem('gpsServers')) {
      Vue.prototype.$gpsServers = JSON.parse(localStorage.getItem('gpsServers'))
    } else {
      Vue.prototype.$gpsServers = Config.gpsServers
    }
    Vue.use(new VueSocketIO({
      debug: false,
      connection: SocketIO(`${Vue.prototype.$gpsServers.server1.url}`, {
        transportOptions: {
          polling: {
            extraHeaders: {
              Authorization: getUserData().token,
              // TE: 'trailers',
            },
          },
        },
      }),
      vuex: {
        store,
      },
      options: {},
    }))
  }
  return next()
})

export default router
